import { useEffect, useState, useContext } from 'react'
import ReactGA from 'react-ga'

import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'

const useGoogleAnalytics = (callback) => {
    const [eventQueue, updateEventQueue] = useState([])
    const [pageviewQueue, updatePageviewQueue] = useState([])
    const trackingContext = useContext(TrackingContext)
    const googleAnalyticsReady = trackingContext.googleAnalyticsReady

    //callback
    useEffect(() => {
        if (googleAnalyticsReady && callback) {
            const ga = ReactGA
            callback(ga)
        }
    }, [googleAnalyticsReady])

    //events
    useEffect(() => {
        if (googleAnalyticsReady && eventQueue.length) {
            eventQueue.forEach(event => {
                try {
                    ReactGA.event(event);
                } catch (err) {
                    console.error(err)
                }
            })
            updateEventQueue([])
        }
    }, [googleAnalyticsReady, JSON.stringify(eventQueue)])


    const sendGoogleAnalyticsEvent = (event) => {

        //if google analytics is ready, don't even put it in the queue, just gonna send it
        if(googleAnalyticsReady) {
            try {
                ReactGA.event(event);
            } catch (err) {
                console.error(err)
            }
        } else {
            updateEventQueue(prevItems => [...prevItems, { ...event }]);
        }
    }

    //pageviews
    useEffect(() => {
        if (googleAnalyticsReady && pageviewQueue.length) {
            const deduplicateQueue = [...new Set(pageviewQueue)]
            deduplicateQueue.forEach(pageview => {
                try {
                    console.debug("Sending Pageview")
                    ReactGA.pageview(pageview);
                } catch (err) {
                    console.error(err)
                }
            })
            updatePageviewQueue([])
        }
    }, [googleAnalyticsReady, JSON.stringify(pageviewQueue)])


    const sendGoogleAnalyticsPageview = (pageview) => {

        //if google analytics is ready, don't even put it in the queue, just gonna send it
        if(googleAnalyticsReady) {
            try {
                console.debug("Sending PageView")
                ReactGA.pageview(pageview);
            } catch (err) {
                console.error(err)
            }
        } else {
            updatePageviewQueue(prevItems => [...prevItems, pageview]);
        }
    }

    return { sendGoogleAnalyticsEvent, sendGoogleAnalyticsPageview }
}

export default useGoogleAnalytics
